module.exports = __webpack_public_path__ + "img/vandana.eee0bf96.jpg";